module.exports = __webpack_public_path__ + "img/header-video-bg-2.0b4be939.webp";